import req from './req'
import persissionMock from '../menu/persissionMock'

export function login (params) {
  return req.post('/login', params)
}

export function getPermission (params) {
  // return persissionMock
  return []
}

export function getPermissionInterface (params) {
  return req.get('/jurisdiction/permission', params)
}

export function getUserInfo () {
  // return {
  //   head_portrait:
  //     'http://mmbiz.qpic.cn/mmbiz_png/1nDJByqmW2fWRCf9MOPpRLdKxwlTEzLqfgIeP8SVeBAWuyMW3K5ACK4PsCX7vDBkOHKSLFXNQrKy8ibaTPpia7TQ/0?wx_fmt=png',
  //   username: '欢迎'
  // }
  return req.get('/account-info')
}

// 刷新token
export function refresh (params) {
  return req.post('/refresh', params)
}

// 退出
export function logout () {
  return req.post('/logout')
}

// 获取头部平台切换URL
export function getAdminUrl () {
  return req.get('/yundian-admin-url')
}

//官网跳转code免登对接
export function getToken (params) {
  return req.post('/oauth_login', params)
}
